import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import Connector from '../containers/container';
import {
  supportedLanguages,
  getLocaleFromUrlPath,
  getLanguageByLocale,
} from 'src/utils/languageUtils';
import { DropdownButton, MenuButton, FlagIcon } from './styled';
import { isEUContinent } from 'src/components/AppLayout/components/constants';

const LanguageMenu = ({ changeLanguage }) => {
  const [language, setLanguage] = useState({ label: null, icon: null });

  useEffect(() => {
    const language = getLanguageByLocale(
      getLocaleFromUrlPath(window.location.pathname),
    );

    setLanguage({
      label: supportedLanguages[language].label,
      icon: supportedLanguages[language].icon,
    });
  }, []);

  const handleMenuClick = ({ label, icon, language }) => {
    setLanguage({ label, icon });
    changeLanguage(language);
    dayjs.locale(language);
  };

  const items = Object.values(supportedLanguages).map(lang => ({
    key: lang.language,
    label: (
      <MenuButton key={lang.language} onClick={() => handleMenuClick(lang)}>
        {lang.label}
      </MenuButton>
    ),
    icon: <FlagIcon src={lang.icon} />,
  }));

  return isEUContinent ? (
    <Dropdown menu={{ items }}>
      <DropdownButton>
        <FlagIcon src={language.icon} />
        {language?.label}
        <DownOutlined />
      </DropdownButton>
    </Dropdown>
  ) : (
    <></>
  );
};

LanguageMenu.propTypes = {
  changeLanguage: PropTypes.func.isRequired,
};

export default Connector(LanguageMenu);
